import {ExchangeType} from "@services/vehicleExchangeService";

export enum ExchangeTypes {
    Permanent = "Permanent",
    Temporary = "Temporary"
}

export type ExchangeReasonState = {
  exchangeType: ExchangeTypes;
  exchangeReason: string;
  comments: string;
};

export type ExchangeReasonAction =
  | { type: "USER_SELECTS_EXCHANGE_TYPE"; payload: string }
  | { type: "USER_SELECTS_EXCHANGE_REASON"; payload: string }
  | { type: "USER_TYPES_COMMENTS"; payload: string };

export const exchangeReasonInitialState: ExchangeReasonState = {
  exchangeType: ExchangeTypes.Permanent,
  exchangeReason: "",
  comments: "",
};

export function exchangeReasonReducer(state: ExchangeReasonState, action: ExchangeReasonAction): ExchangeReasonState {
  switch (action.type) {
    case "USER_SELECTS_EXCHANGE_TYPE": // USER_SELECTS_EXCHANGE_TYPE
      return { ...state, exchangeType: action.payload === ExchangeTypes.Permanent
              ? ExchangeTypes.Permanent : ExchangeTypes.Temporary };
    case "USER_SELECTS_EXCHANGE_REASON":
      return { ...state, exchangeReason: action.payload };
    case "USER_TYPES_COMMENTS":
      return { ...state, comments: action.payload };
    default:
      console.log(`Error - incorrect action sent ${action} ${state}`)
      return state;
  }
}